























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import publishObjectPath from '@/util/configRegistry';
import { dictServe, institutionServer, performanceServer, userServe } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';

@Component({
  components: {},
  mixins: [TableStripe],
})
export default class ChoiceCheckDialog extends Vue {
  private visible = false;
  fileList: any = [];
  finishWayOptions: any = [
    {
      name: '同步完成',
    },
    {
      name: '独立完成',
    },
  ];

  newOptions: any = [
    {
      name: '固定',
    },
    {
      name: '动态',
    },
  ];
  headers: any = {};
  actionUrl: any = '';
  private dialogVisible = false;
  private dialogImageUrl = '';

  private timeRange: any = [];

  // 执行部门
  subSpaceByAuthOptions: any = [];

  // 人员
  spaceStaffByAuthOptions: any = [];

  // 人员
  spaceStaffTwoByAuthOptions: any = [];

  // 职务
  spacePostByAuthOptions: any = [];

  // 任务
  taskOptions: any = [];

  private serverUrl = publishObjectPath.imgPathWater;

  formData: any = {
    id: '',
    annex: '',
    checkDepartmentId: '',
    checkDepartmentName: '',
    checkPostId: '',
    checkPostName: '',
    checkStaffIds: '',
    endTime: '',
    executeDepartmentId: '',
    executeDepartmentName: '',
    executePostId: '',
    executePostName: '',
    executeStaffIds: '',
    finishWay: '',
    name: '',
    parentTaskId: '',
    remark: '',
    startTime: '',
    type: '',
    taskNature: '固定',
  };

  userRules: any = {
    name: [{ required: true, trigger: 'blur', message: '请填写任务名称' }], // 任务名称
    executeDepartmentId: [{ required: true, trigger: 'blur', message: '请选择执行部门' }], // 执行部门
    finishWay: [{ required: true, trigger: 'blur', message: '请选择完成方式' }], // 完成方式
    taskNature: [{ required: true, trigger: 'blur', message: '请选择任务性质' }], // 完成方式
  };

  private async showDialog(data: any) {
    this.actionUrl = publishObjectPath.serverUrl + '/api/sysManage/sysFile';
    this.headers.Authorization = localStorage.getItem('token');
    this.formData.parentTaskId = data.id;
    this.getSubSpaceByAuth();
    this.getTask();
    this.getSinglePerformanceData(data.id);
    this.visible = true;
  }
  getSinglePerformanceData(id: any) {
    performanceServer.getSinglePerformanceData(id).then((res: any) => {
      if (res.code === '200') {
        this.formData = res.data;
        if (res.data.startTime) {
          this.timeRange = [res.data.startTime, res.data.endTime];
        }
        if (res.data.executeDepartmentId) {
          this.getSpaceStaffTwoByAuth(res.data.executeDepartmentId);
          this.getSpacePostByAuth(res.data.executeDepartmentId);
        }
        if (res.data.checkDepartmentId) {
          this.getSpaceStaffByAuthOptions(res.data.checkDepartmentId);
        }
        if (res.data.executeStaffIds) {
          this.formData.executeStaffIds = res.data.executeStaffIds.split(',');
        }
        if (res.data.checkStaffIds) {
          this.formData.checkStaffIds = res.data.checkStaffIds.split(',');
        }
        this.fileList = [];
        if (res.data.annex) {
          res.data.annexList.forEach((item: any) => {
            this.fileList.push({
              id: item.id,
              url: this.serverUrl + item.path,
            });
          });
        }
      }
    });
  }

  /**
   * @description 点击返回按钮 关闭弹窗
   */
  returnDialog() {
    this.fileList = [];
    this.timeRange = [];
    this.visible = false;
    this.$emit('refreshData');
  }

  /**
   * @desc 获取部门所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getSubSpaceByAuth() {
    // 发起接口请求，获取分页数据
    institutionServer
      .getAllData({})
      .then((res: any) => {
        this.subSpaceByAuthOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }
  /**
   * @desc 获取人员数据
   * @param1 暂无
   * @returns 暂无
   */
  getSpaceStaffByAuthOptions(id: any) {
    // 发起接口请求，获取分页数据
    userServe
      .getPageDataAll({ deptId: id })
      .then((res: any) => {
        this.spaceStaffTwoByAuthOptions = res.data;
        this.$forceUpdate();
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取人员数据
   * @param1 暂无
   * @returns 暂无
   */
  getSpaceStaffTwoByAuth(id: any) {
    // 发起接口请求，获取分页数据
    userServe
      .getPageDataAll({ deptId: id })
      .then((res: any) => {
        this.spaceStaffByAuthOptions = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取职务数据
   * @param1 暂无
   * @returns 暂无
   */
  getSpacePostByAuth(id: any) {
    // 发起接口请求，获取分页数据
    performanceServer
      .getSpacePostByAuth({ deptId: id })
      .then((res: any) => {
        this.spacePostByAuthOptions = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取任务类型数据
   * @param1 暂无
   * @returns 暂无
   */
  getTask() {
    const arr: any = [];
    // 发起接口请求，获取分页数据
    dictServe
      .getDetailsMapByName('dutyTaskType')
      .then((res: any) => {
        for (const i in res.data) {
          arr.push({
            value: i,
            label: res.data[i],
          }); //属性
        }
        this.taskOptions = arr;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  private getAll(e: any) {
    this.formData.checkStaffIds = '';
    this.getSpaceStaffByAuthOptions(e);
  }

  private getTwoAll(e: any) {
    this.formData.executeStaffIds = '';
    this.formData.executePostId = '';
    if (e) {
      this.getSpaceStaffTwoByAuth(e);
      this.getSpacePostByAuth(e);
    }
  }

  /**
   * @description 点击保存按钮
   */
  saveDialog() {
    this.subSpaceByAuthOptions.map((res: any) => {
      if (res.id === this.formData.checkDepartmentId) {
        this.formData.checkDepartmentName = res.name;
      }

      if (res.id === this.formData.executeDepartmentId) {
        this.formData.executeDepartmentName = res.name;
      }
    });
    this.spacePostByAuthOptions.map((res: any) => {
      if (res.id === this.formData.executePostId) {
        this.formData.executePostName = res.name;
      }
    });
    const formComponent: any = this.$refs.form;
    formComponent.validate((valid: any) => {
      if (!valid) {
        return;
      }
      if (this.timeRange.length === 0) {
        this.$message.warning('请选择任务时间');
        return;
      }
      this.editFunctionData();
    });
  }

  /**
   * 【接口】行内新增功能
   */
  private async editFunctionData() {
    console.log(this.formData, '234234');
    performanceServer
      .editPerformanceData(this.formData.id, {
        annex: this.formData.annex,
        checkDepartmentId: this.formData.checkDepartmentId ? this.formData.checkDepartmentId : null,
        checkDepartmentName: this.formData.checkDepartmentName ? this.formData.checkDepartmentName : null,
        checkStaffIds: this.formData.checkStaffIds ? this.formData.checkStaffIds.toString() : null,
        endTime: this.timeRange ? (this.timeRange[1] ? this.timeRange[1] : null) : null,
        executeDepartmentId: this.formData.executeDepartmentId ? this.formData.executeDepartmentId : null,
        executeDepartmentName: this.formData.executeDepartmentName ? this.formData.executeDepartmentName : null,
        executePostId: this.formData.executePostId ? this.formData.executePostId : null,
        executePostName: this.formData.executePostName ? this.formData.executePostName : null,
        executeStaffIds: this.formData.executeStaffIds ? this.formData.executeStaffIds.toString() : null,
        finishWay: this.formData.finishWay ? this.formData.finishWay : null,
        name: this.formData.name ? this.formData.name : null,
        remark: this.formData.remark ? this.formData.remark : null,
        startTime: this.timeRange ? (this.timeRange[0] ? this.timeRange[0] : null) : null,
        taskNature: this.formData.taskNature ? this.formData.taskNature : null,
        type: this.formData.type ? this.formData.type : null,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('编辑成功');
          this.returnDialog(); // 返回到父级页面
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch(() => {
        this.$message.error('添加失败');
      });
  }

  private handleSuccess(response: any, file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.annex = arr.toString();
  }
  private handleRemove(file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.annex = arr.toString();
  }

  private handlePictureCardPreview(file: any) {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  }

  closeImgDialog() {
    this.dialogVisible = false;
  }
}
